/* src/app/shared/components/accordion/accordion.component.css */
/*# sourceMappingURL=accordion.component-QITIVO5S.css.map */
